import { useMutation } from '@tanstack/react-query';
import { newsletterApi } from '../api/newsletter.api';
import { toast } from 'sonner';

export const useNewsletterSubscription = () => {
    return useMutation({
        mutationFn: (email: string) => newsletterApi.subscribe(email),
        onSuccess: () => {
            toast.success('Đăng ký thành công! Bạn sẽ nhận được mã giảm giá 10% trong email.');
        },
        onError: (error: Error) => {
            toast.error(`Đăng ký thất bại: ${error.message}`);
        },
    });
};
